import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  radioIcon: {
    borderRadius: '50%',
    width: 24,
    height: 24,
    backgroundColor: theme.palette.colors.white,
    border: [1, 'solid', '#B3B3B3'],
  },
  checkedIcon: {
    borderColor: theme.palette.colors.teal,
    backgroundColor: theme.palette.colors.white,
    '&:before': {
      display: 'block',
      width: 22,
      height: 22,
      backgroundImage: 'radial-gradient(#26A69A,#26A69A 32%,transparent 32%)',
      content: '""',
    },
  },
  radioButton: {
    padding: 10,
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/Radio/useStyles.js